import { Http } from "@Services";
import {
    CreateSharedLinkResponse,
    CreateSharedLinkRequest,
} from "./interfaces";

export const postSharedLink = async (
    data: CreateSharedLinkRequest
): Promise<CreateSharedLinkResponse> => {
    try {
        return await Http.Request<CreateSharedLinkResponse>({
            method: "POST",
            url: "/link",
            data,
        });
    } catch (error) {
        //  @ts-ignore
        throw Error(error);
    }
};

export const getLinkData = async (id: string): Promise<any> => {
    try {
        return await Http.Request<any>({
            method: "GET",
            url: `/link?ch=${id}`,
        });
    } catch (error) {
        throw error;
    }
};

/**
 * Records that this browser arrived at the link's event (ticket 505). Needs the session cookie
 * from a successful `getLinkData` for the same link. The server ignores repeats.
 * Present Mode counts these arrivals as "still answering". Never throws: tracking must not
 * block the voter.
 * @param linkId - The share link id from `?ch=`
 */
export const postLinkScan = async (linkId: string): Promise<void> => {
    try {
        await Http.Request<void>({
            method: "POST",
            url: `/link/${linkId}/scans`,
        });
    } catch {
        // Ignored on purpose.
    }
};

export default {
    postSharedLink,
    getLinkData,
    postLinkScan,
};
